import React from 'react';
import { Link } from 'react-router-dom';

// Ochiq sahifa: Play Market ilova sahifasidan shu manzilga havola beriladi
// (amanah.uz/privacy). Ham sotuvchi, ham admin ilovasi uchun bitta.
const PHONE = '+998 99 444 43 47';
const PHONE_HREF = 'tel:+998994444347';
const UPDATED = '2026-yil 24-oktabr';

const Section: React.FC<{ id?: string; title: string; children: React.ReactNode }> = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-6">
    <h2 className="text-lg font-semibold text-gray-900 mb-2">{title}</h2>
    <div className="space-y-2 text-[15px] leading-relaxed text-gray-700">{children}</div>
  </section>
);

const List: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1">
    {items.map((item, i) => <li key={i}>{item}</li>)}
  </ul>
);

const Phone = () => (
  <a href={PHONE_HREF} className="text-primary-800 font-semibold whitespace-nowrap">{PHONE}</a>
);

export const Privacy: React.FC = () => (
  <div className="min-h-[100dvh] bg-white">
    <div className="max-w-2xl mx-auto px-4 sm:px-6 pt-[calc(env(safe-area-inset-top)+2rem)] pb-[calc(env(safe-area-inset-bottom)+2.5rem)]">
      <div className="flex items-center gap-3 mb-6">
        <img src="/logo.svg" alt="Amanah" className="w-10 h-10 rounded-xl" />
        <span className="text-lg font-bold text-gray-900">Amanah</span>
      </div>

      <h1 className="text-2xl sm:text-[1.75rem] font-bold tracking-tight text-gray-900">Maxfiylik siyosati</h1>
      <p className="mt-1 text-sm text-gray-500">Oxirgi yangilanish: {UPDATED}</p>

      <div className="mt-8 space-y-8">
        <Section title="Umumiy">
          <p>
            Ushbu siyosat Amanah do'kon boshqaruv tizimi (amanah.uz sayti, admin.amanah.uz paneli,
            Amanah Android ilovalari va Telegram boti — keyingi o'rinlarda «Xizmat») qanday
            ma'lumotlarni yig'ishi, ulardan qanday foydalanishi va ularni qanday himoya qilishini
            tushuntiradi. Xizmatdan foydalanish orqali siz ushbu siyosatga rozilik bildirasiz.
          </p>
        </Section>

        <Section title="Qanday ma'lumotlar yig'iladi">
          <p><b>Sotuvchi va xodim hisobi</b> — ro'yxatdan o'tishda siz kiritadigan:</p>
          <List items={[
            "to'liq ism va telefon raqami;",
            'login va parol (parol shifrlangan ko\'rinishda saqlanadi, uni hech kim ko\'ra olmaydi);',
            "Telegram akkauntingiz identifikatori — faqat hisobni Telegram bilan bog'lasangiz.",
          ]} />
          <p><b>Do'kon ma'lumotlari</b> — do'kon nomi, manzili, telefoni, tovarlar, narxlar, buyurtmalar,
            to'lovlar, xarajat va daromadlar, xodimlar va ularning rollari.</p>
          <p><b>Do'kon mijozlari</b> — sotuvchi o'z mijozlari haqida kiritadigan ism, telefon, manzil,
            izoh, xaridlar va qarzdorlik. Bu ma'lumotlarni do'kon o'zi kiritadi va ular uchun
            do'kon javobgar; Amanah ularni faqat do'konga xizmat ko'rsatish uchun saqlaydi.</p>
          <p><b>Obuna to'lovlari</b> — to'lov cheki rasmi yoki fayli, summasi va izohi.</p>
          <p>
            Xizmat joylashuvingiz, kontaktlaringiz, kamera, mikrofon yoki qurilmadagi boshqa fayllarga
            ruxsat so'ramaydi. Chek faylini faqat o'zingiz tanlab yuklaysiz.
          </p>
        </Section>

        <Section title="Ma'lumotlardan qanday foydalaniladi">
          <List items={[
            "hisobingizni yaratish, tasdiqlash va tizimga kirishni ta'minlash;",
            "do'kon ishini yuritish: sotuv, cheklar, hisobotlar, mijozlar qarzini hisoblash;",
            "obuna to'lovlarini tekshirish va obunani faollashtirish;",
            "Telegram orqali kirish va xabarnomalar (Telegram ulangan bo'lsa);",
            "xizmat xavfsizligini ta'minlash va nosozliklarni tuzatish.",
          ]} />
          <p>Ma'lumotlaringiz reklama uchun ishlatilmaydi va sotilmaydi.</p>
        </Section>

        <Section title="Uchinchi tomonlar">
          <p>
            Ma'lumotlar uchinchi shaxslarga berilmaydi. Istisnolar: hisobingizni Telegram bilan
            bog'lasangiz, xabarlar Telegram orqali yuboriladi; mijozga hisob havolasini o'zingiz
            yuborsangiz, havolani olgan kishi o'sha hisobni ko'radi; qonunda belgilangan hollarda
            vakolatli davlat organlarining rasmiy so'roviga ko'ra.
          </p>
          <p>Xizmatda reklama, tahliliy (analytics) yoki kuzatuv vositalari ishlatilmaydi.</p>
        </Section>

        <Section title="Saqlash va himoya">
          <List items={[
            "barcha aloqa HTTPS orqali shifrlangan holda uzatiladi;",
            "parollar qaytarib bo'lmaydigan shifrlangan (hash) ko'rinishda saqlanadi;",
            "har bir do'kon faqat o'z ma'lumotlarini ko'radi, xodimlar esa faqat o'z roliga ruxsat etilgan bo'limlarni;",
            "qurilmangizda faqat tizimga kirish kaliti va menyu ko'rinishi sozlamasi saqlanadi; «Chiqish» tugmasi kirish kalitini o'chiradi.",
          ]} />
          <p>Ma'lumotlar hisobingiz faol bo'lgan muddat davomida saqlanadi.</p>
        </Section>

        <Section id="hisobni-ochirish" title="Hisobni va ma'lumotlarni o'chirish">
          <p>
            Hisobingizni va unga tegishli ma'lumotlarni o'chirish uchun <Phone /> raqamiga qo'ng'iroq
            qiling yoki Telegram orqali yozing. Hisobingizdagi ism va telefon raqamini ayting —
            egalikni tasdiqlaganimizdan so'ng hisob va do'kon ma'lumotlari 30 kun ichida o'chiriladi.
          </p>
          <p>
            Qonun bo'yicha saqlanishi shart bo'lgan moliyaviy yozuvlar (masalan, obuna to'lovlari)
            belgilangan muddatgacha saqlanib, so'ng o'chiriladi.
          </p>
        </Section>

        <Section title="Bolalar">
          <p>Xizmat biznes uchun mo'ljallangan va 16 yoshgacha bo'lgan shaxslarga yo'naltirilmagan.</p>
        </Section>

        <Section title="O'zgarishlar">
          <p>
            Siyosat o'zgarganda yangi matn shu sahifada e'lon qilinadi va yuqoridagi sana yangilanadi.
          </p>
        </Section>

        <Section title="Aloqa">
          <p>Savollar va murojaatlar uchun: <Phone /> (qo'ng'iroq yoki Telegram).</p>
        </Section>
      </div>

      <div className="mt-10 pt-6 border-t border-gray-100 text-sm text-gray-500">
        <Link to="/login" className="text-primary-800 font-semibold">Tizimga kirish</Link>
      </div>
    </div>
  </div>
);
